module.exports = __webpack_public_path__ + "img/bcg-platinion-logo-blue.5118e718.svg";